import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const ReallocatePaymentsEvent = BaseLoanEvent.extend({
  type: z.literal('reallocatePayments'),
  paymentIds: z.array(PaymentId),
});
export type ReallocatePaymentsEvent = z.infer<typeof ReallocatePaymentsEvent>;
